import { bankLabel } from '../../utils/bank';
import React, { useEffect, useState } from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import { fetchSupervisorTerminalReport } from '../../api/supervisor';
import { downloadCSV } from '../../utils/csv';
import './SupervisorTerminalReportPage.css';

const SupervisorTerminalReportPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    fetchSupervisorTerminalReport()
      .then((data) => { if (!cancelled) setRows(data); })
      .catch(() => { if (!cancelled) setError('Impossible de charger le rapport.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const handleDownload = () => {
    if (rows.length === 0) return;
    const header = ['Terminal', 'Type', 'Nom', 'Code', 'Banque Nom', 'Adresse', 'Superviseur'];
    downloadCSV('terminal-rapport.csv', [
      ['Terminal Rapport'], [], header,
      ...rows.map((r) => [r.terminal, r.type, r.nom, r.code, bankLabel(r.banque_seq, r.banque_nom), r.adresse, r.superviseur]),
    ]);
  };

  return (
    <SupervisorLayout>
      <div className="svtr-header">
        <h2 className="svtr-title">Rapport du Terminal</h2>
        {rows.length > 0 && (
          <button type="button" className="svtr-download-btn" onClick={handleDownload}>Télécharger</button>
        )}
      </div>

      {error && <p className="svtr-error">{error}</p>}
      {loading ? (
        <p>Chargement...</p>
      ) : (
        <div className="svtr-table-wrap">
          <table className="svtr-table">
            <thead>
              <tr>
                <th>Terminal</th><th>Type</th><th>Nom</th><th>Code</th>
                <th>Banque Nom</th><th>Adresse</th><th>Superviseur</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.code}>
                  <td>{row.terminal || '—'}</td>
                  <td>{row.type}</td>
                  <td>{row.nom}</td>
                  <td>{row.code}</td>
                  <td>{bankLabel(row.banque_seq, row.banque_nom)}</td>
                  <td>{row.adresse || '.'}</td>
                  <td>{row.superviseur}</td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={7} className="svtr-empty">Aucun terminal.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </SupervisorLayout>
  );
};

export default SupervisorTerminalReportPage;
